import { boolean, date, object, string } from "yup";
import { jobSituations } from "../logics/constants";

export const jobFollowUpSchema = object({
  apply: string().required("L'embauche liée au candidat est obligatoire"),
  jobSituation: string(),
  endOfContract: date()
    .nullable()
    .when("jobSituation", {
      is: (jobSituation: string) =>
        jobSituations.find((option) => option.value === jobSituation)?.endOfContract ?? false,
      then: (schema) => schema.required("La date de fin de contrat est obligatoire"),
      otherwise: (schema) => schema.transform(() => null),
    }),
  nextFollowUpGenerate: boolean().when("jobSituation", {
    is: (jobSituation: string) => jobSituations.find((option) => option.value === jobSituation)?.nextFollowUp ?? false,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.transform(() => false),
  }),
  nextFollowUpDate: date()
    .nullable()
    .when("nextFollowUpGenerate", {
      is: true,
      then: (schema) => schema.required("La date du prochain suivi est obligatoire"),
      otherwise: (schema) => schema.transform(() => null),
    }),
});
